import * as React from 'react';
export const heartSvg = React.forwardRef(function heartSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.519 7.509a2.48 2.48 0 0 0 .731-1.762 2.48 2.48 0 0 0-.731-1.766 2.484 2.484 0 0 0-1.768-.731c-.64 0-1.276.244-1.763.731a270.538 270.538 0 0 1-.745.751L8 5.985 6.01 3.979a2.484 2.484 0 0 0-1.761-.729A2.492 2.492 0 0 0 2.48 7.509L8 13.026l5.519-5.517ZM8 3.5a255.679 255.679 0 0 0 .75-.757 4.234 4.234 0 0 1 3-1.243 4.24 4.24 0 0 1 3.006 1.243A4.231 4.231 0 0 1 16 5.75a4.23 4.23 0 0 1-1.244 2.997l-6.049 6.047a.997.997 0 0 1-1.414 0l-6.05-6.047A4.242 4.242 0 0 1 4.25 1.5a4.234 4.234 0 0 1 3 1.243L8 3.5Z',
    }),
  );
});
heartSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var heart = {
  category: 'icon',
  colorable: true,
  name: 'heart',
  svg: heartSvg,
};
